// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vue-component.process-parameter .details{margin-left:3em}.vue-component.process-parameter .default{font-weight:400}.vue-component.process-parameter h4 code{font-size:1.15em}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
